import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosOrdenTrabajoEnumChoice, ROUTER_PATHS } from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import {
  SaveOrdenTrabajoAsignadaTec,
  SaveOrdenTrabajoVisitaTec,
} from '../../shared/components';
// Fix merge: el barrel exporta la versión de INSTALACIÓN (sin traslado). El
// componente con flujo de traslado se importa directo para enrutar traslados.
import SaveOrdenTrabajoTrasladoTec from '../../shared/components/SaveOrdenTrabajo/SaveOrdenTrabajoAsignadaTec';
import { TipoEntidadOrdenServicioEnumChoice } from '@/shared';

export type InstalacionActualizarTecnicoPageProps = {};

const InstalacionActualizarTecnicoPage: React.FC<
  InstalacionActualizarTecnicoPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  const navigate = useNavigate();

  const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  // validate state
  useEffect(() => {
    if (!data?.data?.id_orden_trabajo) return;
    if (
      data?.data?.estado_orden_trabajo !==
      EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR
    ) {
      setAlert(
        true,
        'La orden de trabajo no esta en estado de espera de actualización',
        AlertSeverityEnum.error
      );
      navigate(returnUrlInstalacionesTecnicoPage);
    }
  }, [data?.data?.id_orden_trabajo]);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returnUrlInstalacionesTecnicoPage} />;

  const tipoServ = data?.data?.agendamiento_data?.tipo_orden_servicio;
  const esVisita = tipoServ === TipoEntidadOrdenServicioEnumChoice.VISITA;
  const esTraslado =
    tipoServ === 'TRASLADO' || (data?.data as any)?.tipo_orden_trabajo === 'TRASLADO';

  if (esVisita) {
    return <SaveOrdenTrabajoVisitaTec
      title="Actualización de Orden de Trabajo"
      ordentrabajo={data.data}
      isCorrentingData={true}
    />
  }

  if (esTraslado) {
    return <SaveOrdenTrabajoTrasladoTec
      title="Actualización de Orden de Trabajo"
      ordentrabajo={data.data}
      isCorrentingData={true}
    />
  }

  return <SaveOrdenTrabajoAsignadaTec
      title="Actualización de Orden de Trabajo"
      ordentrabajo={data.data}
      isCorrentingData={true}
    />
};

export default InstalacionActualizarTecnicoPage;
